import { useEffect } from 'react';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox, { CheckboxProps } from '@material-ui/core/Checkbox';
import ProductImage from '@assets/png/product.png';

import { withStyles } from '@material-ui/core';
import { blue } from '@material-ui/core/colors';
import { IProduct } from '@models/Product.model';

import {
  LoadingImg,
  LoadingText,
  LoadMore,
} from '@pages/Products/components/ListProducts/ListProducts.styles';
import Rolling from '@assets/gif/rolling.gif';
import { useInView } from 'react-intersection-observer';
import { ListProductsLoading } from '@pages/Products/components/ListProducts/loading/ListProducts.loading';
import { ProductRequest } from '@pages/Products/components/AddEquipmentModal/AddEquipmentModal';
import {
  Container,
  Table,
  Td,
  Image,
  Label,
  Th,
  Tr,
  Thead,
  Tbody,
  Trh,
} from '../../../tables.styles';
import { UncheckCircle, CheckCircle } from '../../../components.styles';

import { StyledText, Line } from './ListEquipmentsWithTogle.styles';

const BlueCheckbox = withStyles({
  root: {
    color: blue[300],
    '&$checked': {
      color: blue,
    },
  },
  checked: {},
})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

interface ListProductsProps {
  data?: IProduct[];
  total?: number;
  isLoading: boolean;
  loadMore: () => void;
  dataSelected: ProductRequest[];
  updateDataSelected: (productRequest?: ProductRequest[]) => void;
  hasMore?: boolean;
}

const ListEquipmentsWithTogle = ({
  data,
  total,
  isLoading,
  hasMore,
  dataSelected,
  loadMore,
  updateDataSelected,
}: ListProductsProps) => {
  const { ref, inView } = useInView();
  useEffect(() => {
    if (inView && hasMore) loadMore();
  }, [inView, hasMore]);
  if (isLoading) {
    return <ListProductsLoading />;
  }
  if (!data) {
    return <div />;
  }
  return (
    <Container>
      <StyledText>{`${total} results`}</StyledText>
      <Line />
      <Table>
        <Thead>
          <Trh>
            <Th width={4}>
              <FormControlLabel
                control={
                  <BlueCheckbox
                    icon={<UncheckCircle />}
                    checkedIcon={<CheckCircle />}
                    name="checkedH"
                  />
                }
                label=""
                checked={
                  data.length > 0 &&
                  data.every(i =>
                    dataSelected.map(selected => selected.product).includes(i),
                  )
                }
                onClick={() => {
                  updateDataSelected(
                    data?.map(product => {
                      return {
                        product,
                        quantity: 1,
                        id: `${product.manufacturerId}-${product.id}`,
                      };
                    }),
                  );
                }}
              />
            </Th>
            <Th width={28}>Product Name</Th>
            <Th width={20}>Model #</Th>
            <Th width={16}>Manufacturer</Th>
            <Th width={30}>Description</Th>
          </Trh>
        </Thead>
        <Tbody>
          {data.map(item => (
            <Tr key={JSON.stringify(item)}>
              <Td width={4} isToggle>
                <FormControlLabel
                  control={
                    <BlueCheckbox
                      icon={<UncheckCircle />}
                      checkedIcon={<CheckCircle />}
                      name="checkedH"
                    />
                  }
                  label=""
                  checked={
                    dataSelected.find(
                      selected => selected.product?.id === item.id,
                    ) !== undefined
                  }
                  onClick={() => {
                    updateDataSelected([
                      {
                        product: item,
                        quantity: 1,
                        id: `${item.manufacturerId}-${item.id}`,
                      },
                    ]);
                  }}
                />
              </Td>
              <Td width={28}>
                <Label>
                  {item.imageUrl ? (
                    <Image src={item.imageUrl} alt="" />
                  ) : (
                    <Image src={ProductImage} alt="" />
                  )}
                  {item.name}
                </Label>
              </Td>
              <Td width={20}>{item.model}</Td>
              <Td width={16}>
                {item.manufacturer?.name ? item.manufacturer.name : ''}
              </Td>
              <Td width={30}>{item.description ? item.description : ''}</Td>
            </Tr>
          ))}
          <LoadMore ref={ref}>
            {hasMore ? (
              <LoadMore>
                <LoadingText>Loading more</LoadingText>
                <LoadingImg src={Rolling} alt="loading" />
              </LoadMore>
            ) : (
              <div />
            )}
          </LoadMore>
        </Tbody>
      </Table>
    </Container>
  );
};

export { ListEquipmentsWithTogle };
